/**
 * Dotažení vendor knihovny až ve chvíli, kdy je opravdu potřeba.
 *
 * Swiper a cookie lišta musí být v hlavním bundlu — banner i lišta jsou vidět
 * hned. Choices a GLightbox ale obsluhují věci pod ohybem nebo skryté za
 * kliknutím, a přitom dohromady zabíraly ~36 kB gzip. Na pomalém mobilu to je
 * pásmo, které chybělo obrázku banneru, takže LCP čekalo na knihovny, které
 * návštěvník za celou návštěvu ani nepotřeboval.
 *
 * Každý soubor se stahuje nejvýš jednou — opakovaná volání dostanou tentýž slib.
 */
const rozpracovane = new Map();

export function loadVendor(src) {
    if (rozpracovane.has(src)) return rozpracovane.get(src);

    const slib = new Promise((resolve) => {
        const el = document.createElement('script');
        el.src = src;
        el.async = true;
        el.onload = () => resolve(true);
        // Když se knihovna nestáhne, stránka musí zůstat funkční: select zůstane
        // nativní, galerie se otevře jako obyčejný odkaz na fotku.
        el.onerror = () => resolve(false);
        document.head.appendChild(el);
    });

    rozpracovane.set(src, slib);
    return slib;
}
